module.exports = __webpack_public_path__ + "static/media/full_time_tutor_intro_physics.868e0ea3.jpg";